<template>
  <div>
    <v-dialog
      v-if="mainDialog && dialogDetail"
      v-model="dialogDetail"
      persistent
      max-width="600"
      max-height="300"
      class="d-dialog"
    >
      <v-card style="border-radius: 14px">
        <div v-resize="onResize" id="detail-dialog-admin">
          <div
            class="d-dialog"
            :style="{
              padding:
                windowSize < 600 ? '0px 5px 10px 0px' : '25px 25px 15px 25px'
            }"
          >
            <div style="width: 100%; display: flex">
              <div class="btn-filter-head">Resend Email</div>
            </div>
            <div class="box-detail">
              <b-container
                style="font-family: 'Bai Jamjuree', sans-serif"
                class="accentbv-example-row"
              >
                <b-row
                  style="
                    border-radius: 8px;
                    height: 54px;
                    background-color: #ecf1ff;
                  "
                >
                  <b-col style="height: 100%; padding: 0px" xl>
                    <div
                      style="
                        font-weight: 600;
                        font-size: 14px;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        height: 100%;
                      "
                      class="md-layout"
                    >
                      <div style="width: 5%">#</div>
                      <div style="width: 23%">หมายเลขคำสั่งซื้อ</div>
                      <div style="width: 25%">
                        <div style="height: 50%">
                          ถึงฝ่ายบัญชี
                          <v-tooltip color="rgba(0, 0, 0, 0.8)" right>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                class="mdi mdi-information"
                              ></span>
                            </template>
                            <span v-if="email_ac.length == 0">
                              <div
                                style="
                                  font-family: 'Bai Jamjuree', sans-serif;
                                  font-weight: 500;
                                  font-size: 12px;
                                  text-align: center;
                                "
                              >
                                กรุณาตรวจสอบอีเมลผู้รับฝ่ายบัญชี
                              </div>
                            </span>
                            <span v-else>
                              <div
                                style="
                                  font-family: 'Bai Jamjuree', sans-serif;
                                  font-weight: 500;
                                  font-size: 12px;
                                  text-align: center;
                                "
                              >
                                อีเมลฝ่ายบัญชี
                              </div>
                              <div
                                style="font-size: 10px"
                                v-for="(row, index) in email_ac"
                                :key="index"
                              >
                                <span
                                  style="font-size: 5px"
                                  class="mdi mdi-record"
                                ></span>
                                {{ row.acc_email }}
                              </div>
                            </span>
                          </v-tooltip>
                        </div>
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            height: 50%;
                          "
                        >
                          <v-checkbox
                            @click="checkAllAccounting()"
                            style="margin: 0"
                            :disabled="email_ac.length == 0 ? true : false"
                            v-model="send_accounting"
                            hide-details
                          ></v-checkbox>
                        </div>
                      </div>
                      <div style="width: 10%">
                        <div style="front-s height: 50%;">ถึงลูกค้า</div>
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            height: 50%;
                          "
                        >
                          <!-- :disabled="disableCheckAll()" -->
                          <v-checkbox
                            @click="checkAllCustomer()"
                            style="margin: 0"
                            v-model="send_customer"
                            hide-details
                          ></v-checkbox>
                        </div>
                      </div>
                      <div style="width: 32%">อีเมลลูกค้า</div>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    style="overflow-y: scroll; max-height: 420px; padding: 0px"
                    xl
                  >
                    <div
                      v-for="(row, index) in temp_data"
                      :key="index + row.purchase_id"
                      style="
                        padding: 10px 0 10px 0;
                        margin-top: 10px;
                        border: 0.7px solid rgba(0, 0, 0, 0.2);
                        border-radius: 8px;
                        font-weight: 600;
                        font-size: 14px;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        max-height: 55px;
                      "
                      class="md-layout"
                    >
                      <div style="width: 5%">{{ index + 1 }}</div>
                      <div style="width: 23%">{{ row.purchase_id }}</div>
                      <div class="CB" style="width: 25%">
                        <div style="display: flex; justify-content: center">
                          <input
                            @change="checkBox('acc', row)"
                            v-model="acc_push"
                            :value="row"
                            :disabled="email_ac.length == 0 ? true : false"
                            type="checkbox"
                          />
                        </div>
                      </div>
                      <div class="CB" style="width: 10%">
                        <div style="display: flex; justify-content: center">
                          <!-- :disabled="!row.change_address && row.cus_email != '' ? false : true " -->
                          <input
                            @change="checkBox('cus', row)"
                            v-model="cus_push"
                            :value="row"
                            type="checkbox"
                          />
                        </div>
                      </div>
                      <div
                        class="in-email"
                        style="padding: 0 5px 0 0; width: 37%"
                      >
                        <!-- v-if="!row.change_address && row.cus_email != '' "  -->
                        <div class="search">
                          <span class="form-element">
                            <!-- <span
                              @click="refesh_val(row)"
                              v-if="!row.change_address"
                              style="background-color: #fff; cursor: pointer"
                              class="mdi mdi-refresh mdi-18px"
                            ></span> -->
                            <input
                              @change="changeEmailCustomer($event)"
                              v-model="row.cus_email"
                              :placeholder="row.df_mail"
                            />
                          </span>
                        </div>
                        <!-- <input
                          v-if="row.change_address || row.cus_email == '' "
                          disabled="true"
                          style="
                            width: 100%;
                            height: 28px;
                            background: #d9d9d9;
                            border: 1px solid rgba(0, 0, 0, 0.12);
                            border-radius: 8px;
                          "
                          type="text"
                        /> -->
                      </div>
                      <!-- inp_mail = 0 ==> ปกติ -->
                      <!-- inp_mail = 1 ==> กรอกอีเมล -->
                      <!-- inp_mail = 2 ==> รูปแบบผิด -->
                      <div
                        v-if="row.inp_mail == 1"
                        style="display: flex; width: 100%"
                      >
                        <div style="width: 65%"></div>
                        <small class="txt-wrong">กรุณากรอกอีเมล</small>
                      </div>
                      <div
                        v-else-if="row.inp_mail == 2"
                        style="display: flex; width: 100%"
                      >
                        <div style="width: 65%"></div>
                        <small class="txt-wrong"
                          >กรุณากรอกอีเมลให้ถูกต้อง</small
                        >
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>

            <div class="box-footer">
              <span @click="closeDetailDialog()" style="cursor: pointer"
                >ยกเลิก</span
              >
              <v-btn
                :disabled="
                  data_resend == '' || data_resend.length == 0 ? true : false
                "
                rounded
                @click="submitDetailDialog('save')"
                class="ok"
                :style="{ 'margin-left': '20px' }"
                >ตกลง</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_success"
      persistent
      max-width="350"
      id="dialogCinfrim"
    >
      <v-card style="border-radius: 14px">
        <v-card-title style="background-color: #ecf1ff" class="text-h5">
          <div style="width: 100%">
            <!-- <div style="width: 80%;">บันทึกการเปลี่ยนแปลง</div> -->
            <!-- <div style="justify-content: flex-end;display: flex;width: 20%"><span @click="close_success" style="cursor: pointer;" class="mdi mdi-close mdi-18px"></span></div> -->
            <div style="text-align: center; margin-bottom: 20px">
              <img
                class="img"
                src="@/assets/images/success.png"
                style="height: 120px"
              />
            </div>
            <div
              style="
                font-family: 'Bai Jamjuree';
                text-align: center;
                font-size: 16px;
              "
            >
              ส่งอีเมลสำเร็จ
            </div>
          </div>
        </v-card-title>
        <div style="padding: 15px 0px; text-align: center">
          <v-btn
            rounded
            @click="close_success"
            class="ok"
            :style="{ 'margin-left': '20px' }"
            >ตกลง</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <div class="text-center"></div>
    <v-dialog persistent v-model="confirmResend" max-width="454" width="454">
      <v-card>
        <div class="d-dialog">
          <div
            v-if="loading_status_popup"
            style="z-index: 1000; position: absolute; width: 100%; top: 100px"
          >
            <v-progress-circular
              :size="100"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <div class="bg-confirm">
            <div style="text-align: center">
              <img class="img" src="@/assets/images/mail_resend.png" />
            </div>
            <div
              style="font-family: 'Bai Jamjuree', sans-serif; padding: 0px 10px"
            >
              คุณต้องการ
              <span style="font-weight: bold">ส่งอีเมลอีกครั้ง</span>ใช่หรือไม่
            </div>
          </div>
          <div class="bg-confirm-action">
            <div>
              <v-btn
                rounded
                @click="saveConfirmResend()"
                class="ok"
                style="margin-right: 45px"
                :disabled="loading_status_popup"
                >ใช่</v-btn
              >
              <v-btn
                rounded
                @click="closeConfirmResend()"
                class="clear"
                :disabled="loading_status_popup"
                >ไม่</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
var CryptoJS = require('crypto-js')
export default {
  name: 'admin-user-manage-detail-dialog',
  props: {
    data: Array,
    temp_data: Array,
    email_ac: Array,
    mainDialog: Boolean
    // show: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data () {
    return {
      multiLine: true,
      snackbar: false,
      textSnack: '',
      y: 'top',
      message: 'aaa',
      windowSize: 1366,
      confirmText: '',
      confirmBtn: '',
      confirmDialog: false,
      dialogDetail: true,
      dialogConfrimEdit: false,
      switch1: false,
      editUser: false,
      editPassword: false,
      icon_eye: {
        password: false,
        new_password: false,
        confrim_new_password: false
      },
      edit_val: {
        val_pass: '',
        new_password: '',
        confrim_password: ''
      },
      Error: {
        errorClassNewPwd: '',
        errorClassNewPwd_txt: '',
        errorClassConfNewPwd: '',
        errorClassConfNewPwd_txt: ''
      },
      monthsShort: [
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.'
        // 'JAN',
        // 'FEB',
        // 'MAR',
        // 'APR',
        // 'MAY',
        // 'JUN',
        // 'JUL',
        // 'AUG',
        // 'SEP',
        // 'OCT',
        // 'NOV',
        // 'DEC'
      ],
      tempSnackbar: false,

      titleInput: 'all',
      data_resend: [],
      send_accounting: false,
      send_customer: false,
      Error: {
        errorClassEmail: '',
        errorClassEmail_txt: ''
      },
      check_box_cus: '',
      acc_push: false,
      cus_push: false,
      dialog_success: false,
      confirmResend: false,
      loading_status_popup: false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.show
      },
      set (value) {
        this.close()
      }
    }
  },
  watch: {
    acc_push (newValue) {
      this.send_accounting = newValue
    },
    cus_push (newValue) {
      this.send_customer = newValue
    }
  },
  methods: {
    disableCheckAll () {
      if (this.temp_data[0].cus_email != '') {
        return false
      } else {
        return true
      }
    },
    checkAllAccounting () {
      this.checkAll()
      this.acc_push = this.send_accounting
    },
    checkAllCustomer () {
      this.checkAll()
      this.cus_push = this.send_customer
    },
    checkAll () {
      const res = {
        purchase_id: '',
        send_to: '',
        cus_email: ''
      }
      let param = this.temp_data[0]
      if (this.send_customer || this.send_accounting) {
        if (this.send_customer && this.send_accounting) {
          res.purchase_id = param.purchase_id
          res.send_to = 'accounting/customer'
          res.cus_email = param.cus_email
        } else {
          res.purchase_id = param.purchase_id
          res.send_to = this.send_accounting ? 'accounting' : 'customer'
          res.cus_email = this.send_accounting ? '' : param.cus_email
        }
        this.data_resend = res
      } else {
        this.data_resend = ''
      }
    },
    checkBox (mode, param) {
      const res = {
        purchase_id: '',
        send_to: '',
        cus_email: ''
      }
      if (this.cus_push || this.acc_push) {
        if (this.acc_push && this.cus_push) {
          res.purchase_id = param.purchase_id
          res.send_to = 'accounting/customer'
          res.cus_email = param.cus_email
        } else {
          res.purchase_id = param.purchase_id
          res.send_to = this.acc_push ? 'accounting' : 'customer'
          res.cus_email = this.acc_push ? '' : param.cus_email
        }
        this.data_resend = res
      } else {
        this.data_resend = ''
      }
    },
    changeEmailCustomer (param) {
      // console.log(param)
    },
    refesh_val (param) {
      if (this.data_resend == '') {
        this.temp_data[0].cus_email = param.df_mail
        param.cus_email = param.df_mail
      } else {
        this.data_resend.cus_email = param.df_mail
        param.cus_email = param.df_mail
      }
    },
    submitDetailDialog () {
      // console.log(this.data_resend)
      if (
        this.data_resend.send_to == 'customer' ||
        this.data_resend.send_to == 'accounting/customer'
      ) {
        if (this.temp_data[0].cus_email == '') {
          this.temp_data[0].inp_mail = 1
        } else if (!this.syntaxEmail_(this.temp_data[0].cus_email)) {
          this.temp_data[0].inp_mail = 2
        } else {
          this.temp_data[0].inp_mail = 0
          this.data_resend.cus_email = this.temp_data[0].cus_email
          this.confirmResend = true
          this.dialogDetail = false
          // this.$emit('close', {})
        }
      } else {
        this.confirmResend = true
        this.dialogDetail = false
        // this.$emit('close', {})
      }
    },
    saveConfirmResend () {
      if (this.loading_status_popup == false) {
        this.loading_status_popup = true
        let theArray = []

        theArray.push(this.data_resend)
        this.$store
          .dispatch('resendMail', theArray)
          .then(res => {
            this.loading_status_popup = false
            this.confirmResend = false
            this.dialog_success = true
            this.cus_push = false
            this.send_customer = false
            this.acc_push = false
            this.send_accounting = false
            this.data_resend = ''
            this.$emit('close', {})
          })
          .catch(error => {
            this.loading_status_popup = false
            if (error.response.status == 401) {
              sessionStorage.removeItem('user_profile')
              sessionStorage.removeItem('token_seesion')
              this.tokenExpired = true
              console.log('Error 401')
            }
          })
      }
    },
    checkErrorCase (type, value) {
      if (type == 'inp-email') {
        if (value == null || value == '') {
          ;(this.Error.errorClassEmail = 'error-case'),
            (this.Error.errorClassEmail_txt = this.$t('txt-wrong11'))
          return false
        } else if (!this.syntaxEmail(value)) {
          ;(this.Error.errorClassEmail = 'error-case'),
            (this.Error.errorClassEmail_txt = this.$t('txt-wrong5'))
          return false
        } else {
          ;(this.Error.errorClassEmail = ''),
            (this.Error.errorClassEmail_txt = '')
          return true
        }
      }
    },
    formatDate (val) {
      if (val !== null) {
        let hours = ''
        let min = ''
        let today = new Date(val)
        const year = today.getFullYear()
        const fullYear = year
        // const fullYear = year + 543
        const days = today.getDate()
        const h = today.getHours()
        const m = today.getMinutes()
        const monthName = this.monthsShort[today.getMonth()]

        if (h < 10) {
          hours = '0' + h
        } else {
          hours = h
        }

        if (m < 10) {
          min = '0' + m
        } else {
          min = m
        }

        return (
          days +
          ' ' +
          monthName +
          ' ' +
          fullYear +
          '  ' +
          hours +
          ':' +
          min +
          ' น.'
        )
      } else {
        return val
      }
    },
    cheang_password () {
      this.dialogConfrimEdit = true
    },
    confrim_dialog (param) {
      this.dialogConfrimEdit = false
      if (param == 'OK') {
        this.editPassword = true
      } else {
        // console.log('cancel')
      }
    },
    renderStatus (row, mode) {
      if (mode == 'class') {
        return row.user_status == 1 ? 'active' : 'inactive'
      } else {
        return row.user_status == 1 ? 'Active' : 'Inactive'
      }
    },
    switch_user (param) {
      if (param.user_status == 0) {
        this.data.user_status = 1
      } else {
        this.data.user_status = 0
      }
    },
    closeDetailDialog () {
      this.cus_push = false
      this.send_customer = false
      this.acc_push = false
      this.send_accounting = false
      this.data_resend = ''
      this.$emit('close', {})
      // this.$emit('fetch', {})
    },
    close_success () {
      let status = ''
      if (this.data.user_status == 1) {
        status = 'Active บัญชีผู้ใช้งาน'
      } else {
        status = 'Inactive บัญชีผู้ใช้งาน'
      }
      let detail_snack = {
        status_code: this.data.user_status,
        status: status,
        user_name: this.data.user_name + ' ' + this.data.user_surname,
        show: this.tempSnackbar
      }
      this.dialog_success = false
      this.dialogDetail = true
      this.data_resend = ''
      this.cus_push = false
      this.send_customer = false
      this.acc_push = false
      this.send_accounting = false
      this.$emit('snack', detail_snack)
      this.$emit('close', {})
    },

    onResize () {
      if (this.data.user_status == 1) {
        this.switch1 = true
      } else {
        this.switch1 = false
      }
      let x = window.innerWidth
      let y = window.innerHeight
      this.windowSize = x
      this.deviceType = window.deviceType()
    },
    syntaxEmail_ (email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true
      } else {
        return false
      }
    },
    closeConfirmResend () {
      if (this.loading_status_popup == false) {
        this.cus_push = false
        this.send_customer = false
        this.acc_push = false
        this.send_accounting = false
        this.data_resend = ''
        this.confirmResend = false
        this.dialogDetail = true
        this.$emit('close', {})
      }
    },
    close_s () {
      this.dialog_success = false
    }
  }
}
</script>
<style>
.error-case {
  border: 1px solid red;
  font-size: 12px;
  font-family: 'Bai Jamjuree', sans-serif;
}

.re-
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  padding: 0 0 0 5px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
.in-email .v-text-field .v-input__slot {
  min-height: 0px;
}

.in-email
  .v-text-field.v-input--dense:not(.v-text-field--outlined)
  .v-text-field__prefix,
.v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__suffix,
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 2px 0 2px;
  font-size: 14px;
}

.CB input[type='checkbox'] {
  /* Double-sized Checkboxes */
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  transform: scale(1.5);
  padding: 10px;
}

/* Might want to wrap a span around your checkbox text */
.checkboxtext {
  /* Checkbox text */
  font-size: 100%;
  display: inline;
}

.search {
  color: #000;
  font-size: 14px;
}

.form-element {
  position: relative;
}

.search input {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}

.search input {
  height: 28px;
  width: 100%;
  text-indent: 1em;
}

/* mdi mdi-refresh */
.search .mdi-refresh {
  position: absolute;
  top: 0;
  right: 2px;
  bottom: 0;
}
</style>
